import { UseLoadingReturn } from "@/hooks/use-loading";
import useUpdate from "@/hooks/use-update";
import { IVariationInput } from "@/interfaces/variation.interface";
import productVariationService from "@/services/variation.service";
import { UpdateByIdProps } from "@/types/requests.types";

export type UpdateProductVariationProps = UpdateByIdProps<IVariationInput>;

export type UseUpdateProductVariationReturn = {
  update: (props: UpdateProductVariationProps) => Promise<void>;
} & UseLoadingReturn;

const useUpdateProductVariation = (): UseUpdateProductVariationReturn => {
  const { isLoading, startLoading, endLoading, loadingIcon, update } = useUpdate<IVariationInput>({
    operation: (formData, productVariationId) =>
      productVariationService.update(formData, productVariationId),
  });

  return {
    isLoading,
    startLoading,
    endLoading,
    loadingIcon,
    update,
  };
};

export default useUpdateProductVariation;
